import type { FacilityDocumentPickerItem } from "components/FacilityDocumentPicker";

import { useMemo, useState, type Dispatch, type SetStateAction } from "react";

import { type AddEditDocumentDialogState, EditMode, FormState } from "../types";

type UseDialogStateParams = {
  dialogState: AddEditDocumentDialogState;
  setDialogState: Dispatch<SetStateAction<AddEditDocumentDialogState>>;
};

export function useDialogState({ dialogState, setDialogState }: UseDialogStateParams) {
  const [pickedDocument, setPickedDocument] = useState<FacilityDocumentPickerItem | null>(null);
  const [attestation, setAttestation] = useState(false);
  const [hasInvalidFileExtension, setHasInvalidFileExtension] = useState(false);

  const shouldFieldsBeDisabled = useMemo(
    () => dialogState.mode === EditMode.ADD_OR_PICK && !!pickedDocument,
    [dialogState.mode, pickedDocument]
  );

  const handleDocumentPick = (document: FacilityDocumentPickerItem) => {
    setPickedDocument(document);
    setDialogState((state) => ({
      ...state,
      documentId: document.id,
      title: document.title,
      documentType: document.documentType,
      fileExtension: document.fileExtension,
      storageLink: document.storageLink,
      description: document.description,
      authoredAt: document.authoredAt,
      step: FormState.FORM,
    }));
  };

  return {
    pickedDocument,
    setPickedDocument,
    shouldFieldsBeDisabled,
    attestation,
    setAttestation,
    hasInvalidFileExtension,
    setHasInvalidFileExtension,
    handleDocumentPick,
  };
}
